import React from "react";
import {
  Box,
  CircularProgress,
  FormControlLabel,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

// Presentational only — no API calls of its own. EditComponent.jsx owns the
// preview fetch and the apply call; this just renders the choice and reports
// it back via onScopeChange/onConfirm.
const EditComponentScopeDialog = ({
  open,
  preview,
  scope,
  onScopeChange,
  onBack,
  onConfirm,
  submitting,
}) => {
  return (
    <Modal open={open} onClose={onBack} sx={{ zIndex: 1000 }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95%", md: 460 },
          bgcolor: "background.paper",
          boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
          borderRadius: "20px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2.5,
            bgcolor: "primary.main",
            flexShrink: 0,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#fff", letterSpacing: 0.3 }}
          >
            Apply These Changes To…
          </Typography>
          <IconButton
            onClick={onBack}
            size="small"
            sx={{
              color: "#fff",
              "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
            }}
          >
            <CloseOutlined />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ px: 3, py: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>
          {!preview ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={28} />
            </Box>
          ) : (
            <>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                This component can exist under more than one tier. Choose how
                far these changes should reach.
              </Typography>

              <RadioGroup
                value={scope}
                onChange={(e) => onScopeChange(e.target.value)}
              >
                <FormControlLabel
                  value="self"
                  control={<Radio />}
                  label="Just this component"
                />
                <FormControlLabel
                  value="equipment"
                  control={<Radio />}
                  disabled={!preview.equipment.available}
                  label={
                    preview.equipment.available
                      ? `${preview.equipment.otherCount} other component(s) under ${preview.equipment.label || "this Equipment"}`
                      : "No other components under this Equipment (not applicable)"
                  }
                />
                <FormControlLabel
                  value="plant"
                  control={<Radio />}
                  disabled={!preview.plant.available}
                  label={
                    preview.plant.available
                      ? `${preview.plant.otherCount} other component(s) across this Plant`
                      : "No other components across this Plant (not applicable)"
                  }
                />
              </RadioGroup>
            </>
          )}

          {/* Footer */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
            <Button onClick={onBack}>Back</Button>
            <Button
              type="primary"
              onClick={onConfirm}
              disabled={!preview || submitting}
              style={{ minWidth: 100 }}
            >
              {submitting ? <CircularProgress size={22} color="inherit" /> : "Apply"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditComponentScopeDialog;
